import { SubscriptionService } from '@affine/core/modules/cloud';
import { useLiveData, useService } from '@toeverything/infra';
import { useEffect } from 'react';

/**
 * Base and demo plan of the server (plan rows, `plan_role`); null until the
 * plan roles are loaded.
 */
export function usePlanRoles(): {
  basePlan: string | null;
  demoPlan: string | null;
} {
  const planRoles = useService(SubscriptionService).planRoles;
  const roles = useLiveData(planRoles.roles$);
  useEffect(() => {
    if (planRoles.roles$.value === null) planRoles.revalidate();
  }, [planRoles]);
  return {
    basePlan: roles?.basePlan ?? null,
    demoPlan: roles?.demoPlan ?? null,
  };
}
